// import jQuery from 'CommonScripts/jquery-1.10.2';
(function (window, document, $) {
    var searchTypeEnum = {
        TypeSignType: 1,
        TypeSignSize: 2,
        TypeSignVariant: 3,
        Accessory: 4
    };
    $(document).ready(function () {
        var $root = document.querySelectorAll('.stockAvailabilityContainer');
                $root = $($root);
        //$.components.registerComponent('.stockAvailabilityContainer', function ($root) {
            var stockAvailabilityContainer = {
                dom: {
                    container: $root,
                    selectType: $root.find('#windowType'),
                    selectSize: $root.find('#windowSize'),
                    selectVariant: $root.find('#windowVariant'),
                    defaultTypeText: $root.find('#DefaultTypeText'),
                    defaultSizeText: $root.find('#DefaultSizeText'),
                    defaultVariantText: $root.find('#DefaultVarientText'),
                   
                    visitDealerButtonText: $root.find('#VisitDealerButtonText'),
                    btnSearch: $root.find('#btnSearch'),
                    divProductContainer: $root.find('.productConfiguration'),
                    divProduct: $root.find('.productConfiguration .product'),
                    divResultContainer: $root.find('.stockAvailabilityResults'),
                    divResult: $root.find('.stockAvailabilityResults .results'),
                    resultsText: $root.find('#ResultsHeadline'),
                    h2ResultTitle: $root.find('.stockAvailabilityResults h2:first-child'),
                    divCCLoading: $root.find('#divCCLoading'),
                    btnLinksToDealer: $root.find(".stockAvailabilityResults .button a"),
                    divAlerts: $root.find('#divAlerts'),
                    divCustomError: $root.find('#divCustomError'),
                    divSystemError: $root.find('#divSystemError'),
                    ulSystemError: $root.find('#divSystemError ul'),
                    divResultError: $root.find('.resultError'),
                    errorLocationNotFound: $root.find('#LocationNotFoundText'),
                    errorGeneral: $root.find('#GeneralErrorText'),
                    dealerId: $root.find("#dealerId"),
                    currentlanguage: $root.find("#currentLanguage"),
                    dealerImageUrl: $root.find("#dealerImageUrl")
                },
                set: {
                    prefilteredProductId: null
                },
                fn: {
                    Init: function () {
                        $fn.DisableInput($dom.selectSize);
                        $fn.DisableInput($dom.selectVariant);
                        $fn.HideResult();
                        $fn.HideResultError();
                        $dom.divAlerts.hide();
                        //populate type
                        $fn.ProductFilterChanged($dom.selectType, "", "");

                        //search for product if productId is passed in url
                        var productId = $fn.GetURLParameter("productId");
                        if (productId != null && productId !== "") {
                            
                            productId = productId.split("%20");
                            var type = productId[0];
                            var size = productId[1];
                            var variant = productId[2];
                            $set.prefilteredProductId = type + " " + size + " " + variant;
                            $fn.GetStockAvailability(type, size, variant);
                        }

                    },
                    HideResult: function () {
                        $dom.divProductContainer.hide();
                        $dom.divResultContainer.hide();
                    },
                    ShowResult: function () {
                        $dom.divProductContainer.show();
                        $dom.divResultContainer.show();
                        $fn.ScrollToResult();
                    },
                    ScrollToResult: function () {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $dom.divResultContainer.offset().top - 30
                        }, 1000);
                    },
                    CleanResult: function () {
                        $dom.divProduct.empty();
                        $dom.divResult.empty();
                        $fn.HideStoreButtons();
                    },
                    HideDiv: function (id) {
                        $dom.container.find("#" + id).hide();
                    },
                    EnableInput: function (element) {
                        element.prop('disabled', false);
                    },
                    DisableInput: function (element) {
                        element.prop('disabled', 'disabled');
                    },
                    HideError: function () {
                        $dom.divAlerts.hide();
                        $dom.divAlerts.find("div").hide();
                    },
                    ShowError: function (error) {
                        $fn.HideResult();
                        $fn.HideError();
                        $dom.divAlerts.show();
                        $dom.ulSystemError.html("<li>" + error + "</li>");
                        $dom.divSystemError.show();

                    },
                    ShowCustomError: function (id) {
                        $fn.HideResult();
                        $fn.HideError();
                        $dom.divAlerts.show();
                        $dom.divAlerts.find("#" + id).show();
                        $dom.divCustomError.show();
                    },
                    ShowResultError: function (text) {
                        $dom.divResultError.text(text);
                        $dom.divResultError.show();
                    },
                    HideResultError: function () {
                        $dom.divResultError.hide();
                    },
                    Loader: function () {
                        if ($dom.divCCLoading.css('display') == 'none') {
                            $dom.divCCLoading.show();
                        } else {
                            $dom.divCCLoading.hide();
                        }
                    },
                    GetStockAvailability: function (type, size, variant) {
                        $fn.HideResult();
                        $fn.ServiceGetStockAvailability(type, size, variant, $fn.RenderResult);
                    },
                    RenderResult: function (result) {

                        if (result) {
                            $fn.CleanResult();
                            if (result.StatusCode.StatusCode == null || result.StatusCode.StatusCode != 200 || result.Data.ProductId == null || result.Data.productId == "undefined") {
                                $fn.ShowError("No Results found for product " + $set.prefilteredProductId); //TODO: replace with sitecore text
                                return;
                            }
                            //PRODUCT INFORMATION - NOT SHOWN
                            // if(result.Data){
                            //     var productContent = 
                            //          "<div class=\"image-wrapper\">"
                            //         +"<img src=\"img/velux-window.jpg\" alt=\"\">"
                            //         +"</div>"
                            //         +"<div class=\"article-wrapper\">"
                            //         +"<strong>"+result.Data.ProductId+"</strong>"
                            //         +"<p>NEED DESCRIPTION</p>"
                            //         +"</div>"
                            //     $dom.divProduct.append(productContent);
                            // }

                            if (result.Data.Stores != "undefined" && result.Data.Stores.length > 0) {
                                $dom.h2ResultTitle.text($dom.resultsText.val() + " " + result.Data.ProductId);
                                $fn.SetStoreButtonUrls(result.Data.ConfiguratorUrl, result.Data.DealerName);
                                $fn.ShowStoreButtons();
                            } else {
                                $fn.ShowError("No Results found for product " + $set.prefilteredProductId); //TODO: replace with sitecore text
                                return;
                            }

                            //create product html
                            $.each(result.Data.Stores, function () {
                                //create store html
                                var elem = document.createElement("div");
                                elem.classList.add("result");
                                elem.innerHTML =
                                    "<div class=\"logo\"><img src=\"" + $dom.dealerImageUrl.val() + "\" alt=\"dealer-logo\"></div>"
                                    + "<div class=\"info\">"
                                    + "<div class=\"title\">" + this.Name + "</div>"
                                    + "<div class=\"address\">"
                                    + "<i class=\"icon marker-gray\"></i>"
                                    + "<p>" + this.Fulladdress.replace(/(?:\r\n|\r|\n)/g, '<br />') + "</p>"
                                    + "</div>"
                                    + "<div class=\"availability\"><span class=\"dot " + this.ProductStatus + "\"></span><p class=\"status\">" + this.ProductStatusText + "</p>"
                                    + "<p class=\"deliveryInfo\">"+ this.ProductStatusStockText +"</p>"
                                    + "</div>"
                                    + "</div>";

                                $dom.divResult.append(elem);
                            });



                            $fn.ShowResult();
                        }
                    },
                    SetStoreButtonUrls: function (url, dealerName) {
                        $dom.btnLinksToDealer.each(function () {
                            $(this).html($dom.visitDealerButtonText.val() + " <i class=\"velux-icon icon-chevron-right-white\"></i>");
                            $(this).prop("href", url);
                        });
                    },
                    ShowStoreButtons: function () {
                        $dom.btnLinksToDealer.show();
                    },
                    HideStoreButtons: function () {
                        $dom.btnLinksToDealer.hide();
                        $dom.btnLinksToDealer.each(function () {
                            $(this).html("");
                            $(this).prop("href", "");
                        });
                    },
                    ServiceGetStockAvailability: function (type, size, variant, loadFunction) {
                        $fn.Loader();
                        $.ajax({
                            type: "GET",
                            cache: false,
                            url: "/api/sitecore/ClickCollect/SearchProduct",
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            data: $.param({
                                dealerId: $dom.dealerId.val(),
                                language: $dom.currentlanguage.val(),
                                type: type,
                                size: size,
                                varient: variant
                            }),
                            success: function (result) {
                                loadFunction(result);
                                $fn.Loader();
                                return false;
                            },
                            error: function (request, status, error) {
                                $fn.ShowCustomError(error);
                                $fn.Loader();
                            }
                        });
                        return false;
                    },
                    //Dropdowns
                    ProductFilterChanged: function (dropdownlist, typeSignType, typeSignSize) {
                        $fn.ServiceFilterProduct(function (facets) {
                            var output = [];
                            output.push($fn.GetDefaultOption(dropdownlist));
                            var valueArray = facets[Object.keys(facets)[0]];
                            $.each(valueArray,
                                function () {
                                    output.push(
                                        '<option value="' +
                                        this +
                                        '">' +
                                        this +
                                        '</option>');
                                });

                            dropdownlist.html(output.join(''));
                        },
                            typeSignType,
                            typeSignSize);
                    },
                    ServiceFilterProduct: function (loadFunction, typeSignType, typeSignSize) {
                        $fn.Loader();

                        var searchTypeSelected = searchTypeEnum.TypeSignType;
                        if (typeSignType !== "") {
                            searchTypeSelected = searchTypeEnum.TypeSignSize;
                            if (typeSignType !== "" && typeSignSize !== "") {
                                searchTypeSelected = searchTypeEnum.TypeSignVariant;
                            }
                        }
                        var ReqUrl = "";
                        var ReqData = [];
                        switch (searchTypeSelected) {
                            case searchTypeEnum.TypeSignType:
                                {
                                    ReqUrl = "/api/sitecore/ClickCollect/WindowTypes";
                                    ReqData = {
                                    };
                                    break;
                                }
                            case searchTypeEnum.TypeSignSize:
                                {
                                    ReqUrl = "/api/sitecore/ClickCollect/WindowSizes";
                                    ReqData = {
                                        type: typeSignType
                                    };
                                    break;
                                }
                            case searchTypeEnum.TypeSignVariant:
                                {
                                    ReqUrl = "/api/sitecore/ClickCollect/WindowVarients";
                                    ReqData = {
                                        type: typeSignType,
                                        size: typeSignSize
                                    };
                                    break;
                                }
                        }
                        $.ajax({
                            type: "GET",
                            cache: false,
                            url: ReqUrl,
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            data: $.param(ReqData),
                            success: function (result) {
                                loadFunction(result.Data);
                                $fn.Loader();
                            },
                            error: function (request, status, error) {
                                $fn.ShowError(error);
                                $fn.Loader();
                            }
                        });
                    },
                    GetDefaultOption: function (dropdownlist) {
                        switch (dropdownlist.selector) {
                            case "#windowType":
                                return '<option value="">' +
                                    $dom.defaultTypeText.val() +
                                    '</option>';
                            case "#windowSize":
                                return '<option value="">' +
                                    $dom.defaultSizeText.val() +
                                    '</option>';
                            case "#windowVariant":
                                return '<option value="">' +
                                    $dom.defaultVariantText.val() +
                                    '</option>';
                        }
                    },
                    
                    //URL
                    GetURLParameter: function (paramName) {
                        var sPageURL = window.location.search.substring(1);
                        var sURLVariables = sPageURL.split('&');
                        for (var i = 0; i < sURLVariables.length; i++)
                        {
                            var sParameterName = sURLVariables[i].split('=');
                            if (sParameterName[0] == paramName)
                            {
                                return sParameterName[1];
                            }
                        }

                    }
                }
            },

                $dom = stockAvailabilityContainer.dom,
                $set = stockAvailabilityContainer.set,
                $fn = stockAvailabilityContainer.fn;

            $fn.Init();

            $dom.btnSearch.on({
                click: function (e) {
                    e.preventDefault();
                    $fn.HideError();
                    var type = $dom.selectType.val();
                    var size = $dom.selectSize.val();
                    var variant = $dom.selectVariant.val();

                    if (type === "") {
                        $fn.ShowCustomError("WindowTypeErrorEmpty");
                    } else {
                        if (size === "") {
                            $fn.ShowCustomError("WindowSizeErrorEmpty");
                        } else {
                            if (variant === "") {
                                $fn.ShowCustomError("WindowVariantErrorEmpty");

                            } else {
                                $fn.GetStockAvailability(type, size, variant);
                            }
                        }
                    }

                    return false;
                }
            });
            $dom.selectType.on({
                change: function (e) {
                    $fn.HideError();
                    $dom.selectSize.empty();
                    $dom.selectVariant.empty();
                    $fn.DisableInput($dom.selectSize);
                    $fn.DisableInput($dom.selectVariant);
                    if ($dom.selectType.val() != null && $dom.selectType.val() !== "") {
                        $fn.ProductFilterChanged($dom.selectSize, $dom.selectType.val(), "");
                        $fn.EnableInput($dom.selectSize);
                    }

                }
            });

            $dom.selectSize.on({
                change: function (e) {
                    $fn.HideError();
                    $dom.selectVariant.empty();
                    $fn.DisableInput($dom.selectVariant);
                    if ($dom.selectType.val() != null &&
                        $dom.selectType.val() !== "" &&
                        $dom.selectSize.val() != null &&
                        $dom.selectSize.val() !== "") {

                        $fn.ProductFilterChanged($dom.selectVariant,
                            $dom.selectType.val(),
                            $dom.selectSize.val());
                        $fn.EnableInput($dom.selectVariant);
                    }
                }
            });

            $dom.selectVariant.on({
                change: function (e) {
                    $fn.HideError();
                }
            });

        //});

       // $.components.compInit();
    });
})(window, document, jQuery);